/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { ColorToken } from "@panda/tokens";

export type CosmosTextAs = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "div";

export enum CosmosTextVariantEnum {
	"heading2XL" = "heading2XL",
	"headingXL" = "headingXL",
	"headingLG" = "headingLG",
	"headingMD" = "headingMD",
	"headingSM" = "headingSM",
	"paragraph2XL" = "paragraph2XL",
	"paragraphXL" = "paragraphXL",
	"paragraphLGBold" = "paragraphLGBold",
	"paragraphLG" = "paragraphLG",
	"paragraphMD" = "paragraphMD",
	"paragraphSM" = "paragraphSM",
	"paragraphXS" = "paragraphXS",
	"uiLG" = "uiLG",
	"uiMD" = "uiMD",
	"uiSM" = "uiSM",
	"eyebrowLG" = "eyebrowLG",
	"eyebrowMD" = "eyebrowMD",
	"eyebrowSM" = "eyebrowSM",
}

export type CosmosTextVariants = keyof typeof CosmosTextVariantEnum;

export const cosmosTextVariantArray = [
	"heading2XL",
	"headingXL",
	"headingLG",
	"headingMD",
	"headingSM",
	"paragraph2XL",
	"paragraphXL",
	"paragraphLGBold",
	"paragraphLG",
	"paragraphMD",
	"paragraphSM",
	"paragraphXS",
	"uiLG",
	"uiMD",
	"uiSM",
	"eyebrowLG",
	"eyebrowMD",
	"eyebrowSM",
] as const;

export interface CosmosVariableRichText {
	variant?: CosmosTextVariants | null;
	as?: CosmosTextAs | null;
	html?: string | null;
	text?: string | null;
	color?: ColorToken;
}

export type VariantType = "heading" | "paragraph" | "ui" | "eyebrow";
